import {EventEmitter2} from 'eventemitter2'
import Promise from 'bluebird'
import request from 'superagent'

import store from '@/store'
import {toCamelCase} from '@/misc/change-prop-case'

Promise.config({
  cancellation: true,
})

request.Request.prototype.then = function (onFulfilled, onRejected) {
  let promise = new Promise((resolve, reject, onCancel) => {
    let req = this.end((err, res) => {
      if (err) reject(err)
      else resolve(res)
    }).on('error', reject)
    onCancel(() => {
      req.abort()
    })
  })
  return promise.then(onFulfilled, onRejected)
}

class APIClient extends EventEmitter2 {
  constructor (apiEndpoint, subAPIs) {
    super()
    this.apiEndpoint = apiEndpoint
    this.adminApiEndpoint = `${apiEndpoint}admin/`
    this.token = null
    this.crmApiEndpoint = null
    this.asShop = null
    this.asGroup = null
    this.defaultTimeout = 300000

    this.plugins = {
      checkError: (request) => {
        let origEnd = request.end
        request.end = (fn) => {
          return origEnd.call(request, (err, res) => {
            if (res && res.body) {
              res.body = toCamelCase(res.body)
            }
            if (err && !res) {
              // サーバが死んでいるときなど
              console.error(`Unexcepted request error: ${request.url}, ${err}`)
              this.emit('error', err)
            } else {
              if (!res.ok) {
                switch (res.status) {
                  case 400:
                    break
                  case 401:
                    this.emit('error', err)
                    break
                  case 404:
                  case 409:
                    // case 429: // Too Many Requests (throttled)
                    // 無視する
                    break
                  case 408:
                    // timeout
                    // falls through
                  case 504:
                    break
                  default:
                    console.error('Unexcepted request error', err, res)
                    this.emit('error', err, res)
                }
              } else {
                request.emit('success', res)
              }
              fn(err, res)
            }
            request.emit('finish', err, res)
          })
        }
        return request
      },
      setToken: (request) => {
        if (this.token) {
          return request.set('Authorization', 'token ' + this.token)
        }
        return request
      },
      setAsShop: (request) => {
        if (this.asShop) {
          return request.set('X-SHOP-AS', this.asShop)
        }
        return request
      },
      setAsGroup: (request) => {
        if (this.asGroup) {
          return request.set('X-GROUP-AS', this.asGroup)
        }
        return request
      },
      getPageSize () {
        return store.getters['setting/pageSize']
      },
      setDefaultTimeout: (request) => {
        return request.timeout(this.defaultTimeout)
      },
      setAccept: request => {
        return request.set('Accept', 'application/json')
      },
    }
    subAPIs(this)
  }

  init () {
  }

  reset () {
    this.token = null
    this.asShop = null
    this.crmApiEndpoint = null
  }

  setToken (token) {
    this.token = token
  }

  setCrmApiEndpoint (crmApiEndpoint) {
    // MEMO: バージョンを無理やり2にする
    if (crmApiEndpoint) {
      crmApiEndpoint = crmApiEndpoint.replace(/\/1.0\//, '/2.0/')
    }
    this.crmApiEndpoint = crmApiEndpoint
  }

  setAsShop (shopPk) {
    this.asShop = shopPk
  }

  setAsGroup (groupPk) {
    this.asGroup = groupPk
  }

  getPageSize () {
    return store.getters['setting/pageSize']
  }

  getUploadHeaders () {
    return {
      Authorization: `Token ${this.token}`,
      Accept: 'application/json',
    }
  }
}
APIClient.request = request

// HTTP
// superagent を生で使うこともできるが、APIClientのメソッドを使うことで、
// 頻繁に使うプラグインのセットを省略できる

;[ 'get', 'head', 'del', 'patch', 'post', 'put', 'options' ].forEach(method => {
  APIClient.prototype[method] = function () {
    let req = request[method].apply(request, arguments)
      .use(this.plugins.setToken)
      .use(this.plugins.setAsShop)
      .use(this.plugins.setAsGroup)
      .use(this.plugins.setAccept)
      .use(this.plugins.setDefaultTimeout)
      .use(this.plugins.checkError)
      .on('response', res => {
        this.emit('response', res)
      })
    this.emit('request', req)
    return req
  }
})

request.parse['application/json'] = function (body) {
  let data = JSON.parse(body)
  return data
}

export default APIClient



// WEBPACK FOOTER //
// ./src/request/index.js